import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { sharedUiTranslations } from '../../translations';
import styles from './Balance.module.css';
export const BalanceBase = ({ amount, currency = 'R$', label, className, style, ...props }) => {
    const { t } = useTranslation();
    const displayLabel = label !== undefined ? label : t('balance.label');
    const formatAmount = (value) => {
        if (typeof value === 'number') {
            return value.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }
        return value;
    };
    const combinedClassName = [styles.container, className].filter(Boolean).join(' ');
    return (_jsxs("div", { className: combinedClassName, style: style, "data-testid": 'balance-container', ...props, children: [displayLabel && (_jsx("span", { className: styles.label, "data-testid": 'balance-label', children: displayLabel })), _jsxs("span", { className: styles.value, "data-testid": 'balance-value', children: [currency, " ", formatAmount(amount)] })] }));
};
export const Balance = props => {
    return (_jsx(TranslationProvider, { translations: sharedUiTranslations, defaultLanguage: 'pt-BR', children: _jsx(BalanceBase, { ...props }) }));
};
export default Balance;
